/**
 * Dashboard theme keys map to CLI react-terminal theme ids.
 * CLI should read: new URLSearchParams(window.location.search).get('theme')
 */
export const CONSOLE_TERMINAL_THEMES = {
  ocean: 'material-ocean',
  graphite: 'dark',
  emerald: 'matrix',
};

export const CONSOLE_THEME_OPTIONS = [
  { label: 'Ocean', value: 'ocean' },
  { label: 'Graphite', value: 'graphite' },
  { label: 'Emerald', value: 'emerald' },
];

const STORAGE_KEY = 'eo4eu-console-theme';

export function getStoredConsoleTheme() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && CONSOLE_TERMINAL_THEMES[stored]) return stored;
  } catch {
    // ignore
  }
  return 'ocean';
}

export function setStoredConsoleTheme(theme) {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // ignore
  }
}

export function getCliThemeId(dashboardTheme) {
  return CONSOLE_TERMINAL_THEMES[dashboardTheme] || CONSOLE_TERMINAL_THEMES.ocean;
}

/** Appends ?theme=<cliThemeId>&embed=1 to the console base URL. */
export function buildConsoleUrl(baseUrl, dashboardTheme) {
  const theme = getCliThemeId(dashboardTheme);
  const url = new URL(baseUrl, window.location.href);
  url.searchParams.set('theme', theme);
  url.searchParams.set('embed', '1');
  return url.toString();
}
